import { render, staticRenderFns } from "./TeamMember.vue?vue&type=template&id=22c82ca2&scoped=true"
import script from "./TeamMember.vue?vue&type=script&lang=js"
export * from "./TeamMember.vue?vue&type=script&lang=js"
import style0 from "./TeamMember.vue?vue&type=style&index=0&id=22c82ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c82ca2",
  null
  
)

export default component.exports